<template>
  <div>
    <a-dialog
      v-model="isOpen"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="actionClick('cancel')"
      persistent
    >
      <v-card>
        <v-toolbar :color="options.color" dense>
          <span>{{ $t("lblUnsavedData") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon large>
            <v-icon>mdi-comment-question</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="black--text">
          {{ $t("msgUnsavedData") }}
        </v-card-text>
        <v-card-actions class="pt-0 justify-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                :disabled="disableSave"
                color="primaryDark"
                small
                @click="actionClick('save')"
                v-on="on"
                v-bind="attrs"
                class="mr-2"
                ><span>{{ $t("btnSave") }}</span></a-btn
              >
            </template>
            <span> {{ $t("btnSave") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-on="on"
                v-bind="attrs"
                color="secondary"
                small
                @click="actionClick('discard')"
                class="mr-2"
                ><span>{{ $t("btnDiscard") }}</span></a-btn
              >
            </template>
            <span> {{ $t("btnDiscard") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-on="on"
                v-bind="attrs"
                color="secondary"
                small
                @click="actionClick('cancel')"
                ><span>{{ $t("btnCancel") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnCancel") }} </span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </a-dialog>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import ADialog from "../wrapper-component/ADialog.vue";
import ABtn from "../wrapper-component/ABtn.vue";
export default {
  name: "PreventNavigation",
  components: {
    ADialog,
    ABtn,
  },
  props: {
    prevent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disableSave: false,
      options: {
        color: "primaryLight1",
        width: 400,
        zIndex: 200,
        noconfirm: false,
        yesNoButtons: false,
      },
      isOpen: false,
      nextRouteParams: null,
      unregisterRouteGuard: () => {},
    };
  },
  mounted() {
    const unregister = this.$router.beforeResolve((to, from, next) => {
      beforeRouteChange.call(this, to, from, next);
    });
    this.unregisterRouteGuard = unregister;
  },

  beforeDestroy() {
    this.unregisterRouteGuard();
  },

  methods: {
    actionClick,
    ...mapMutations({
      setSwitchTenantId: "setSwitchTenantId",
    }),
  },
};

async function beforeRouteChange(to, from, next) {
  this.disableSave = to.params.isDisable;
  if (this.prevent && to.name !== "SessionExpired") {
    this.nextRouteParams = { to, from, next };
    this.isOpen = true;
  } else {
    next();
  }
}

function actionClick(name) {
  this.isOpen = false;
  const params = { ...this.nextRouteParams };
  if (name === "cancel") {
    this.setSwitchTenantId(sessionStorage.getItem("tenantId"));
    sessionStorage.setItem("isTenantSwitch", false);
  }
  this.$emit(name, params);
}
</script>
